import React from 'react';

import FormRecurringMeetingsSelection from 'Shared/components/FormComponents/FormRecurringMeetingsSelection';
import { WorkspaceType } from 'Shared/constants/types';

function CreateGroupWorkspacesFormFields() {
  return (
    <div className="CreateGroupWorkspacesFormFields d-flex flex-column">
      <div className="mb-4">
        The following <b>group meetings</b> were found in your calendar. Select the ones you wish to create a workspace
        for.
      </div>
      <FormRecurringMeetingsSelection
        selector="recurringMeetings"
        type={WorkspaceType.isGroup}
        label="Group Meetings from Calendar"
      />
    </div>
  );
}

export default CreateGroupWorkspacesFormFields;
